import Observer from './Observer'
import Emitter  from './Emitter'

let observer = ''

export { observer }

export default {
  install (Vue, connection, store) {
    if (!connection) throw new Error('[Vue-Socket.io] cannot locate connection')

    observer = new Observer(connection, store)

    Vue.prototype.$sockets = observer
    Vue.prototype.$socket  = observer.of('/')

    Vue.mixin({
      created () {
        let vmSockets = this.$options['sockets']

        this.$options.sockets = new Proxy({}, {
          set: (target, key, value) => {
            if (typeof value === 'function') {
              Emitter.addListener(key, value, this)
            } else if (typeof value === 'object') {
              Object.keys(value).forEach(listenerName => {
                Emitter.addListener(`${key}_${listenerName}`, value[listenerName], this)
              })
            }
            target[key] = value
            return true
          },
          deleteProperty: (target, key) => {
            let socket = vmSockets[key]
            if (typeof socket === 'function') {
              Emitter.removeListener(key, socket, this)
            } else if (typeof socket === 'object') {
              Object.keys(socket).forEach(listenerName => {
                Emitter.removeListener(`${key}_${listenerName}`, socket[listenerName], this)
                delete target[key].key
              })
            }
            delete target.key
            return true
          }
        })

        if (vmSockets) {
          Object.keys(vmSockets).forEach((key) => {
            this.$options.sockets[key] = vmSockets[key]
          })
        }
      },
      beforeDestroy () {
        let vmSockets = this.$options['sockets']

        if (vmSockets) {
          Object.keys(vmSockets).forEach((key) => {
            delete this.$options.sockets[key]
          })
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/plugins/vue-multichannel-scoketio/index.js